import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavItemViewModel } from '../nav-item-view-model';
import { NavItemComponent } from '../nav-item.component';

@Component({
  selector: 'app-mobile-profile-nav-item',
  templateUrl: './mobile-profile-nav-item.component.html',
  styleUrls: ['./mobile-profile-nav-item.component.scss', '../nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NavItemViewModel]
})
export class MobileProfileNavItemComponent extends NavItemComponent {
  public isNavItemActive$ = this.viewModel.isNavItemActive$;
  public multiLineNavItem$ = this.viewModel.multiLineNavItem$;
  public hasIcons$ = this.viewModel.hasIcons$;
}
